{
  "IncludeintransitioningsequenceLabel": "Inclure dans la séquence d'affichage de transition du rapport :",
  "RptdisplintervaltimeLabel": "Intervalle d'affichage du rapport :",
  "RptdisplintervaltimePlaceholder": "5s",
  "DisplaySwitching_SectionHeader": "Commutation automatique de l'affichage du rapport",
  "NAME": "DisplaySwitching"
}